//jQuery
import jQuery from 'jquery'
import 'jquery-serializejson'

//Bootstrap
import 'bootstrap/js/src/alert'
import 'bootstrap/js/src/collapse'
import 'bootstrap/js/src/dropdown'
import 'bootstrap/js/src/modal'

//Wirebox core
import EventBus from '../../shared/js/wirebox/event-bus'

//Wirebox utilities
import '../../shared/js/wirebox/utilities/bind-action-to-elem'
import '../../shared/js/wirebox/utilities/dynamic-inputs'
import '../../shared/js/wirebox/utilities/sticky-footer'
import '../../shared/js/wirebox/utilities/sync-child-heights'

//Wirebox components
import '../../shared/js/wirebox/components/anchor-scroll'
import '../../shared/js/wirebox/components/collapse-responsive'
import '../../shared/js/wirebox/components/csrf-token'
import '../../shared/js/wirebox/components/max-length-focus'
import '../../shared/js/wirebox/components/scroll-top-target'
import '../../shared/js/wirebox/components/sticky-header'

//Shared components
import '../../shared/js/components/datepickers'
import '../../shared/js/components/form-validation'
import '../../shared/js/components/stacktable'

//Frontend components
import './components/add-gclid-to-form-submit'
import './components/address-inputs'
import './components/gclid'
import './components/lazy-load'
import './components/scroll-on-collapse'
import './components/stripe-form'
import './components/tidio'

//Wirebox modules
//import '../../shared/js/wirebox/modules/google-analytics-loader'

//Shared modules
import '../../shared/js/modules/confirmation'
import '../../shared/js/modules/error-modal'
import '../../shared/js/modules/success-modal'

//Frontend modules
import './modules/cookie-bar'
import './modules/help-form'
import './modules/lead-form'
import './modules/manual-address-form'
//import './modules/order-form'
import './modules/shipping-form'
import './modules/us-rep-form'

//Add jQuery to global window object
global.jQuery = jQuery

//Run modules
EventBus.run()